import React from 'react';
import { TrendingUp, TrendingDown, DollarSign, Users } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useTranslationDir } from '../../hooks/useTranslationDir';

export const TransactionStatsCards = ({ stats }) => {
  const { t, i18n } = useTranslation();
  const { isRTL } = useTranslationDir();

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat(i18n.language === 'ar' ? 'ar' : 'en-US', {
      style: 'currency',
      currency: 'EGP',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(amount);
  };

  const statCards = [
    {
      title: t('transactions.totalIncome'),
      value: formatCurrency(stats.totalIncome),
      count: stats.incomeTransactions,
      icon: TrendingUp,
      color: 'bg-green-50 text-green-600',
      borderColor: 'border-green-200'
    },
    {
      title: t('transactions.totalOutcome'),
      value: formatCurrency(stats.totalOutcomes),
      count: stats.outcomeTransactions,
      icon: TrendingDown,
      color: 'bg-red-50 text-red-600',
      borderColor: 'border-red-200'
    },
    {
      title: t('transactions.netAmount'),
      value: formatCurrency(stats.netBalance),
      count: stats.totalTransactions,
      icon: DollarSign,
      color: stats.netBalance >= 0 ? 'bg-blue-50 text-blue-600' : 'bg-orange-50 text-orange-600',
      borderColor: stats.netBalance >= 0 ? 'border-blue-200' : 'border-orange-200'
    },
    {
      title: t('transactions.activeUsers'),
      value: stats.activeUsers,
      count: stats.totalTransactions,
      icon: Users,
      color: 'bg-purple-50 text-purple-600',
      borderColor: 'border-purple-200'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      {statCards.map((stat, index) => {
        const Icon = stat.icon;
        return (
          <div key={index} className={`bg-white rounded-xl !border ${stat.borderColor} p-6`}>
            <div className="flex items-center justify-between mb-4">
              <div className={`p-3 rounded-xl ${stat.color}`}>
                <Icon size={24} />
              </div>
            </div>
            <h3 className="text-slate-600 text-sm font-medium mb-1">{stat.title}</h3>
            <p className="text-2xl font-bold text-slate-900 mb-1">{stat.value}</p>
            <p className="text-sm text-slate-500">
              {stat.count} {t('transactions.transactions')}
            </p>
          </div>
        );
      })}
    </div>
  );
};
